var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceRequirmentsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service_Requirments_Icon_-_Integration",
    "data-name": "Service Requirments Icon - Integration",
    transform: "translate(-596 -534)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_637",
    "data-name": "Rectangle 637",
    width: 60,
    height: 60,
    transform: "translate(596 534)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "verified_FILL1_wght400_GRAD0_opsz24",
    d: "M60.727-843l-5.182-8.686-9.818-2.171.955-10.043L40-871.5l6.682-7.6-.955-10.043,9.818-2.171L60.727-900,70-896.064,79.273-900l5.182,8.686,9.818,2.171L93.318-879.1,100-871.5l-6.682,7.6.955,10.043-9.818,2.171L79.273-843,70-846.936Zm6.409-18.864L82.545-877.2l-3.818-3.936L67.136-869.6l-5.864-5.7-3.818,3.8Z",
    transform: "translate(556 1435.5)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequirmentsIcon);
export default __webpack_public_path__ + "static/media/ServiceRequirmentsIcon.4a4ec06d03d9fe3d2ca6e8b729a510a6.svg";
export { ForwardRef as ReactComponent };